import { initGrid } from 'utils/grid/grid';
import { fetchLinkedRetailers } from 'user/actions/linked-retailers.actions';
import template from './linked-retailers-table.html';

const LICENSE_RENEWAL_SERVICE_LABEL = 'clicenseRenewalService';

const mapStateToThis = ({ session, linkedRetailers, ui, config, dictionary }) => {
  const { list, isLoading } = linkedRetailers;
  const { privilegeDisplayTypes } = dictionary;
  const licenseAccessLabel = privilegeDisplayTypes[LICENSE_RENEWAL_SERVICE_LABEL]
    ? privilegeDisplayTypes[LICENSE_RENEWAL_SERVICE_LABEL].value
    : '';
  const { pagination } = ui;
  const { retailer } = session;
  const { defaultPageNo, sortColumnKey, directionKey } = config;

  return {
    licenseAccessLabel,
    list,
    isLoading,
    retailer,
    pagination,
    defaultPageNo,
    sortColumnKey,
    directionKey,
  };
};

const mapDispatchToThis = {
  fetchLinkedRetailers,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'tableService')
class LinkedRetailersTableController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.filters = {};
    this.headers = this.getHeaders();
    this.initDefaultSortColumn();

    this.setInitialFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  setInitialFilters() {
    this.gridModel = initGrid(this.fetchLinkedRetailers, this.defaultParams);

    this.gridModel.pagingModel.filters = {
      ...this.gridModel.pagingModel.filters,
      directAssignment: this.directAssignment,
      isLinkedRetailers: true,
    };
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Retailer No.'),
        field: 'retailerDisplayNumber',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Store No.'),
        field: 'storeNumber',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Name'),
        field: 'retailerName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Address'),
        field: 'address',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Zip'),
        field: 'zip',
        sortable: true,
        textAlignment: 'text-right',
      },
    ];
  }

  initDefaultSortColumn() {
    this.defaultSortColumn = 'storeNumber';
    this.defaultSortDirection = 'true';
    this.defaultParams = {
      [this.sortColumnKey]: this.defaultSortColumn,
      [this.directionKey]: this.defaultSortDirection,
    };
  }

  search() {
    this.gridModel.applyFilters();
  }

  clearFilters() {
    this.setInitialFilters();
    return this.search();
  }

  isSelected({ retailerId }) {
    return this.selectedRetailers.find((retailer) => retailer.retailerId === retailerId);
  }

  isLicensingAccessSelected({ retailerId }) {
    return this.selectedRetailers.find((retailer) => retailer.retailerId === retailerId && retailer.licensingAccess);
  }

  select(retailer) {
    const isAlreadySelected = this.isSelected(retailer);

    if (isAlreadySelected) {
      const selectedRetailers = this.selectedRetailers.filter((selectedRetailer) => selectedRetailer.retailerId !== retailer.retailerId);
      const updatedRetailer = this.selectedRetailers.find((selectedRetailer) => selectedRetailer.retailerId === retailer.retailerId);
      updatedRetailer.licensingAccess = false;
      this.selectedRetailers = [...selectedRetailers];
    } else if (!isAlreadySelected) {
      this.selectedRetailers = [...this.selectedRetailers, ...[retailer]];
    }

    this.onRetailerSelect({ selectedRetailers: this.selectedRetailers });
  }

  selectLicensingAccess(retailer) {
    const isLicensingAccessSelected = this.isLicensingAccessSelected(retailer);

    if (isLicensingAccessSelected) {
      const updatedRetailer = this.selectedRetailers.find((selectedRetailer) => selectedRetailer.retailerId === retailer.retailerId);
      updatedRetailer.licensingAccess = false;
    } else if (!isLicensingAccessSelected) {
      const isAlreadySelected = this.isSelected(retailer);
      if (!isAlreadySelected) {
        this.selectedRetailers = [...this.selectedRetailers, ...[retailer]];
      }
      const updatedRetailer = this.selectedRetailers.find((selectedRetailer) => selectedRetailer.retailerId === retailer.retailerId);
      updatedRetailer.licensingAccess = true;
    }

    this.onRetailerSelect({ selectedRetailers: this.selectedRetailers });
  }
}

export default class LinkedRetailersTableComponent {
  constructor() {
    this.controller = LinkedRetailersTableController;
    this.template = template;
    this.bindings = {
      selectedRetailers: '<',
      disabled: '<?',
      disabledLicenseAccess: '<?',
      onRetailerSelect: '&',
      multiselect: '<?',
      directAssignment: '<?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-retailers/components/linked-retailers-table/linked-retailers-table-component.js